export default __webpack_public_path__ + "static/media/catalogue-title.590bc279.jpg";